module.exports = __webpack_public_path__ + "media/images/vacancies-bg-04-9ee0df576af37fa0b49fb7ad9e370336.png";